import React from "react";
import { HintView } from "lib/components/index";

const Hint = () => (
  <HintView.Hint>
    <h3>{I18n.t("papp.settings.BillingSettingsView.hint.p1")}</h3>
    <p>{I18n.t("papp.settings.BillingSettingsView.hint.p2")}</p>
  </HintView.Hint>
);

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/settings/BillingSettingsView/BillingSettingsHint.jsx